const loadJS = (url, callback) => {
  try {
    var script = document.createElement('script');
    script.src = url;
    script.addEventListener('load', function () {
      if (typeof callback === 'function') callback();
    });
    document.head.appendChild(script);
  } catch (error) {
    console.info(error);
  }
};

export const domToImg = () => {
  loadJS(
    'https://cdn.jsdelivr.net/npm/dom-to-image@2.6.0/dist/dom-to-image.min.js'
  );
};
